import React, { useEffect, useState } from "react";
export default function PuertoSelect({ selectedPuerto, setSelectedPuerto }) {
    const [puertos, setPuertos] = useState([]);
  
    useEffect(() => {
      fetch("https://msoftperu.azurewebsites.net/home/GetPuerto")
        .then((response) => response.json())
        .then((data) => setPuertos(data))
        .catch((error) => console.error("Error fetching puertos:", error));
    }, []);
  
    return (
      <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 ">
        <label className="font-semibold mr-2">Puerto:</label>
        <select 
          className="border border-gray-400 rounded-lg p-2 text-lg"
          value={selectedPuerto}
          onChange={(e) => setSelectedPuerto(e.target.value)}
        >
          {puertos.map((puerto) => (
            <option key={puerto.CODIGO} value={puerto.CODIGO}>
              {puerto.PUERTO}
            </option>
          ))}
        </select>
      </div>
    );
  }
  